import { ApplicationState } from '../../ApplicationState'
import { getNavigationState } from '../V2State'

export const FETCH_NAVIGATION = 'V2/Navigation'

export const fetchNavigation = () => ({
    type: FETCH_NAVIGATION,
    payload: ({ fetchSimple, getState }) => {
        const state: ApplicationState = getState()

        if (getNavigationState(state).loaded) {
            return
        }

        return fetchSimple(`/navigation-data`).then(data => ({
            data,
        }))
    },
})
